module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAElBMVEUAAABwr/NxrvJwr/RwrvFxrvKO6aAVAAAABXRSTlMAQMAwb8qbgvYAAAAuSURBVAjXY8AGmAyYFcAMVgHGABSGaigQBAEZhqKOIoHCmGrgUnDFmGoQVmACAGrJCKOhhKnUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/mine/number.png
// module id = 1368
// module chunks = 5